import type {ViewType, WorkspaceModelType} from "../../stores/WorkspaceStore";
import {clearSearch} from "./clearSearch";
import {selectItemPlain} from "./selectItem";
import {clearAllTempState} from "./clearAllTempState";


import {screenSizeProvider} from "../../stores/ScreenSizeProvider";
import {RootStoreModel} from "@stores/RootStore";


export const changeView = (rootStore: RootStoreModel, view: ViewType, workspace: WorkspaceModelType) => {
    const isMobile = screenSizeProvider.view !== 'desktop';

    clearSearch(rootStore);
    clearAllTempState(rootStore);
    if (!isMobile) {
        selectItemPlain(rootStore, workspace, null);
    }
    workspace.setView(view);
}